import i18next from 'i18next';

import { FIELD_NAMES } from './constants';

export const getFieldLabel = (field) => {
    const name = FIELD_NAMES[field];
    if (name) return i18next.t(name);
    return field || '';
};
